export type AssignmentStatus = 'active' | 'scheduled' | 'expired' | 'revoked';

/** Атрибуты условий правила видимости (раздел orders). */
export enum RuleAttribute {
  RecipientGeo = 'recipient.geo',
  RecipientTag = 'recipient.tag',
  RecipientRetailer = 'recipient.retailer',
  AuthorTag = 'author.tag',
  ProductTag = 'product.tag',
  ProductBrand = 'product.brand',
}

/** К какой группе конструктора относится атрибут (по макету). */
export enum AttrGroup {
  Recipient = 'recipient',
  Products = 'products',
  Author = 'author',
}
/** Тип значения атрибута: строковый uid/фиас или числовой id (товарные атрибуты). */
export enum AttrValueType {
  String = 'string',
  Number = 'number',
}
/** Источник вариантов значений. */
export enum AttrSource {
  Geo = 'geo',
  RecipientTag = 'recipientTag',
  Retailer = 'retailer',
  AuthorTag = 'authorTag',
  ProductTag = 'productTag',
  ProductBrand = 'productBrand',
}

export interface IAttrMeta {
  attribute: RuleAttribute;
  group: AttrGroup;
  valueType: AttrValueType;
  source: AttrSource;
  /** Ключ перевода человекочитаемого названия в namespace `assignments`. */
  labelKey: string;
}

/** Значение условия: строка (uid/фиас) для всех атрибутов, число (id) для товарных. */
export type RuleValue = string | number;

/** Списки значений одного атрибута в конструкторе. */
export interface IncludeExclude {
  include: RuleValue[];
  exclude: RuleValue[];
}

/** Состояние конструктора: ключ — атрибут, значение — его два списка. */
export type VisibilityState = Record<string, IncludeExclude>;

/** Направление, в какой список попадёт следующее выбранное значение. */
export type Mode = 'include' | 'exclude';
